import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  baseProfile: "tiny",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}
const _hoisted_3 = ["fill"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }

import { computed } from 'vue';
import { TagTypes, TagSize, TagBorderColour, TagBgColour } from '@/enums/tag-enums';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';

const xsBase = 'pl-[0.25rem] pr-[0.375rem] py-[0.125rem] rounded-lg justify-start items-center  inline-flex';
const smBase = 'pl-1.5 pr-2 py-1 rounded-lg justify-start items-center gap-2 inline-flex';
const linkBreakBase = 'pl-2 pr-3 py-2 rounded-lg justify-start items-center gap-2 inline-flex';
const lgBase = 'pl-3 pr-4 py-2 rounded-lg justify-start items-center gap-2 inline-flex';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tag',
  props: {
    tagText: {},
    tagType: {},
    tagSize: {},
    tagBgColour: {},
    tagBorderColour: {},
    outerClass: {},
    textClass: {}
  },
  setup(__props: any) {

const props = __props;

const textClass = computed(() => {
  switch (props.tagSize) {
    case TagSize.xs:
    case TagSize.sm:
    case TagSize.linkBreak:
      return 'text-xs';
    case TagSize.lg:
      return 'text-sm';
  }

  return smBase;
});

const tagSizeClass = computed(() => {
  switch (props.tagSize) {
    case TagSize.xs:
      return xsBase;
    case TagSize.sm:
      return smBase;
    case TagSize.lg:
      return lgBase;
    case TagSize.linkBreak:
      return linkBreakBase;
  }

  return smBase;
});

const tagFillColour = computed(() => {
  if (props.tagBgColour == TagBgColour.infoBlue || props.tagBorderColour == TagBorderColour.darkblue) return '#003478';
  if (props.tagBgColour == TagBgColour.note || props.tagBorderColour == TagBorderColour.orange) return '#D56702';
  if (props.tagBgColour == TagBgColour.error || props.tagBorderColour == TagBorderColour.red) return '#D82900';
  if (props.tagBgColour == TagBgColour.success || props.tagBorderColour == TagBorderColour.green) return '#128750';

  return '#444444';
});

const tagBgColourClass = computed(() => {
  switch (props.tagBgColour) {
    case TagBgColour.trueWhite:
      return 'bg-racq-true-white';
    case TagBgColour.note:
      return 'bg-racq-background-note';
    case TagBgColour.error:
      return 'bg-racq-error-red/10';
    case TagBgColour.success:
      return 'bg-racq-success-green/10';
    case TagBgColour.antiFlashWhite:
      return 'bg-racq-anti-flash-white';
    case TagBgColour.lightHighlightPurple:
      return 'bg-racq-light-purple';
    case TagBgColour.infoBlue:
    default:
      return 'bg-racq-info-blue/10';
  }
});

const tagBorderColourClass = computed(() => {
  switch (props.tagBorderColour) {
    case TagBorderColour.darkblue:
      return 'border-2 border-racq-blue';
    case TagBorderColour.orange:
      return 'border-2 border-racq-warning-orange2';
    case TagBorderColour.red:
      return 'border-2 border-racq-error-red';
    case TagBorderColour.green:
      return 'border-2 border-solid border-racq-alert-success';
    case TagBorderColour.lightblue:
      return 'border-2 border-racq-blue-border';
    default:
      return '';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([tagSizeClass.value, tagBgColourClass.value, tagBorderColourClass.value, _ctx.outerClass])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex gap-0.5 items-center text-racq-dark-grey", textClass.value])
    }, [
      (props.tagType == _unref(TagTypes).discount)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_openBlock(), _createElementBlock("svg", _hoisted_2, [
              _createElementVNode("path", {
                fill: tagFillColour.value,
                d: "M17.687 8.575l.318-4.14c.067-.39-.108-.943-.39-1.227l-.412-.412-.412-.412c-.283-.28-.835-.456-1.226-.39l-4.14.32c-.39.065-.937.355-1.214.64l-7.956 7.957c-.463.48-.3 1.404.176 1.875l2.39 2.392 2.393 2.39c.47.476 1.396.64 1.874.177l7.956-7.956c.288-.276.578-.823.644-1.213zm-3.994-2.268c-.53-.53-.53-1.388 0-1.917.53-.53 1.388-.53 1.917 0 .53.53.53 1.387 0 1.917s-1.387.53-1.917 0z"
              }, null, 8, _hoisted_3)
            ]))
          ]))
        : _createCommentVNode("", true),
      (props.tagType == _unref(TagTypes).success)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _cache[0] || (_cache[0] = [
            _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\"><g clip-path=\"url(#clip0_6911_88866)\"><path d=\"M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM11.51 6.19L7.68 10.89C7.53 11.06 7.33 11.16 7.12 11.16C6.91 11.16 6.71 11.07 6.56 10.9L4.53 8.68C4.23 8.39 4.23 7.87 4.53 7.55C4.66 7.4 4.85 7.31 5.05 7.3C5.27 7.3 5.48 7.39 5.63 7.55L7.08 9.12L10.33 5.12C10.46 4.95 10.68 4.84 10.88 4.84H11.08V4.87C11.22 4.89 11.34 4.96 11.44 5.06C11.76 5.34 11.8 5.86 11.52 6.19H11.51Z\" fill=\"#128750\"></path></g><defs><clipPath id=\"clip0_6911_88866\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
          ])))
        : _createCommentVNode("", true),
      (props.tagType == _unref(TagTypes).star)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _cache[1] || (_cache[1] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "17",
              viewBox: "0 0 16 17",
              fill: "none"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7.69997 2.57957C7.75247 2.45368 7.86498 2.375 8 2.375C8.13502 2.375 8.24753 2.45368 8.30003 2.57957L9.7702 6.21457C9.80021 6.29325 9.87522 6.34833 9.95773 6.3562L13.7082 6.69452C13.8357 6.70239 13.9482 6.7968 13.9857 6.93056C14.0232 7.06432 13.9857 7.20594 13.8882 7.29249L11.0454 9.88105C10.9853 9.93613 10.9553 10.0305 10.9703 10.1092L11.8179 13.9567C11.8479 14.0904 11.7954 14.232 11.6904 14.3107C11.5854 14.3894 11.4429 14.3973 11.3304 14.3265L8.10501 12.2887C8.03 12.2414 7.94749 12.2414 7.87249 12.2887L4.64711 14.3265C4.5346 14.3973 4.39208 14.3894 4.28707 14.3107C4.18206 14.232 4.12955 14.0904 4.15956 13.9567L5.00715 10.1092C5.02216 10.0227 4.99965 9.93613 4.93215 9.88105L2.11182 7.30035C2.01431 7.21381 1.9768 7.07218 2.01431 6.93843C2.05181 6.80467 2.16433 6.71812 2.29184 6.70239L6.04227 6.36407C6.12478 6.36407 6.19979 6.30112 6.2298 6.22244L7.69997 2.57957Z",
                fill: "#003478"
              })
            ], -1)
          ])))
        : _createCommentVNode("", true),
      (props.tagType == _unref(TagTypes).purpleStar)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              width: "16",
              height: "17",
              viewBox: "0 0 16 17",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M7.69997 2.20457C7.75247 2.07868 7.86498 2 8 2C8.13502 2 8.24753 2.07868 8.30003 2.20457L9.7702 5.83957C9.80021 5.91825 9.87522 5.97333 9.95773 5.9812L13.7082 6.31952C13.8357 6.32739 13.9482 6.4218 13.9857 6.55556C14.0232 6.68932 13.9857 6.83094 13.8882 6.91749L11.0454 9.50605C10.9853 9.56113 10.9553 9.65554 10.9703 9.73422L11.8179 13.5817C11.8479 13.7154 11.7954 13.857 11.6904 13.9357C11.5854 14.0144 11.4429 14.0223 11.3304 13.9515L8.10501 11.9137C8.03 11.8664 7.94749 11.8664 7.87249 11.9137L4.64711 13.9515C4.5346 14.0223 4.39208 14.0144 4.28707 13.9357C4.18206 13.857 4.12955 13.7154 4.15956 13.5817L5.00715 9.73422C5.02216 9.64768 4.99965 9.56113 4.93215 9.50605L2.11182 6.92535C2.01431 6.83881 1.9768 6.69718 2.01431 6.56343C2.05181 6.42967 2.16433 6.34312 2.29184 6.32739L6.04227 5.98907C6.12478 5.98907 6.19979 5.92612 6.2298 5.84744L7.69997 2.20457Z",
                fill: "#5C11A7"
              })
            ], -1)
          ])))
        : _createCommentVNode("", true),
      (props.tagType == _unref(TagTypes).person)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M17.6209 13.2886C16.6322 12.5594 15.0989 12.0655 13.9275 11.8067C15.1404 10.9678 15.8798 9.39189 15.8798 7.89436C15.8881 7.75324 15.8881 7.60427 15.8798 7.46314C15.7635 5.44031 13.9191 3.89574 11.7757 4.00551C9.62392 4.13095 7.98724 5.87153 8.11186 7.89436C8.11186 9.39189 8.85127 10.9678 10.0642 11.8067C8.90112 12.0655 7.36778 12.5594 6.37082 13.2886C5.5151 13.8845 5 14.8253 5 15.8367V17.8204C5 19.9373 10.9153 20 12 20C13.2353 20 19 19.9373 19 17.8204V15.8446C19 14.8332 18.4849 13.8923 17.6209 13.2964V13.2886Z",
                fill: "#0864BC"
              })
            ], -1)
          ])))
        : _createCommentVNode("", true),
      _createVNode(_unref(RichText), {
        field: { value: _ctx.tagText },
        class: _normalizeClass([textClass.value, "pl-1"]),
        tag: "span"
      }, null, 8, ["field", "class"])
    ], 2)
  ], 2))
}
}

})